// extracted by mini-css-extract-plugin
export var infoItem = "_ub-2";
export var title = "_ub-0";
export var value = "_ub-1";